module.exports = __webpack_public_path__ + "img/acero-galvanizado.01e4893f.jpg";